import { render, staticRenderFns } from "./TestsDebugger.vue?vue&type=template&id=dc53e146&scoped=true&"
import script from "./TestsDebugger.vue?vue&type=script&lang=ts&"
export * from "./TestsDebugger.vue?vue&type=script&lang=ts&"
import style0 from "./TestsDebugger.vue?vue&type=style&index=0&id=dc53e146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc53e146",
  null
  
)

export default component.exports